/*
* 多选下拉树工具
* 创建时间：2018/1/4
* 创建人：bxx
*/
<template>
	 <div style="position:relative;">                            <!-- style="background: #47ac89;color: #fff;border-width: 0;border-radius: 4px;" -->
		<input type="text" :id="'input_'+randomNumber" class="form-control menuInputBrand" maxlength="0" @click="showMenu" :value="selStatus" >
		<b class="select-down-arrow"></b>
		<div :id="'content_'+randomNumber" class="menuContent" style="display:none; position: absolute;">
			<ul :id="'tree_'+randomNumber" class="ztree ztree-slide" style="margin-top:0; width:100%; max-height: 300px;height:auto !important;"></ul>
		</div>
	</div>
</template>
<script>
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import { queryTree } from 'util/util'
	
export default{
	name:'MultiSelectTree',
	data(){
		return {
			randomNumber:'',
			treeObj:{},
			groupList:[],
			mounted:false,
			selectCompanysArr:[],         //选中的救援公司
			selStatus:'请选择'
		}
	},
	props:{ 
		//是否立即加载
		isTreeInit:{
			type:Boolean,
			default:true
		},
		//是否为全选中状态
		isCheckAll:{
			type:Boolean,
			default:false
		},
		//zTree相关配置项
		setting:{
			type:Object,
			required:true
		},
		//请求地址
		url:{
			required:true
		},
		//请求方法，默认为GET
		method:{
			type:String,
			default:'get'
		},
		//请求携带参数
		para:{
			type:Object,
			default(){
				return {}
			}
		},
	},
	created(){ 
		//获取毫秒，保持ID唯一性
		this.randomNumber =new Date().getTime()
	},
	mounted(){
		//设置配置项，如未配置，采用默认值
		this.setting.data.simpleData = this.setting.data.simpleData || {}
		this.setting.data.key = this.setting.data.key || {}
	},
	beforeMount(){
		if(this.isTreeInit){
			this.getTree()
		} 
		//设置配置项，如未配置，采用默认值
		if(this.setting.callback){
			this.setting.callback.onCheck = this.setting.callback.onClick||this.onClick
		}else{
			this.setting.callback = {};
			this.setting.callback.onCheck = this.onClick
		}
		
	},
	methods:{
		//显示、隐藏下拉树
			showMenu(){
				$("#content_"+this.randomNumber).slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			onBodyDown(event){
				var self = this;
				if (!(event.target.id == 'input_'+this.randomNumber || event.target.id == 'content_'+this.randomNumber || $(event.target).parents("#content_"+this.randomNumber).length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$("#content_"+this.randomNumber).fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($('#tree_'+this.randomNumber), this.setting, this.groupList); 
			},                     
			onClick(event,treeId,treeNode){//点击树节点
				let id = treeNode[this.setting.data.simpleData.idKey]||treeNode.id;
				if (treeNode.checked){
					this.selectCompanysArr.push(id);
				}else{
					let index = this.selectCompanysArr.findIndex(function(value, index, arr) {
					   return value == id;
					});
					if (index != -1){
						this.selectCompanysArr.splice(index,1);
					}
				}
				this.$emit('input',this.selectCompanysArr)
				let selLen = this.selectCompanysArr.length
				if(selLen === this.groupList.length){
					this.selStatus = '全部'
				}else if(selLen === 0){
					this.selStatus = '请选择'
				}else{
					this.selStatus = `已选择${selLen}项`
				}
			},
			//拉取数据
			getTree(){
				this.$http[this.method](process.env.API_INSURANCE_ROOT+this.url,{params:this.para})
				.then(res=>{
					if(res.body.success){
						this.groupList = res.body.data;
						this.groupList.map(item=>{
							item.name=item.groupName;
					    })
						this.treeInit()
						//设置默认为全选中状态
						if(this.isCheckAll == true){
							this.selStatus="全部"
							this.selectCompanysArr = [];
							var treeObj = $.fn.zTree.getZTreeObj('tree_'+this.randomNumber);
							var node = treeObj.getNodes();
			    			var nodes = treeObj.transformToArray(node);
							nodes.forEach( item => {
								item.checked = true;
								this.selectCompanysArr.push(item.id);
							})
							this.$emit('input',this.selectCompanysArr)
							treeObj.refresh();
						}
						this.$emit('onsuccess')//加载成功回调
						
					}else{
						this.$emit('onerror',res.body.message)
					}
				},res=>{
					this.$emit('onerror',res.body.message)
				}).catch(res=>{
					this.$emit('onerror','请求异常')//加载失败回调
				})
			},
			//信息重置1：全选，2：清空
			reSet(isCheck){
				this.selectCompanysArr = [];
				var treeObj = $.fn.zTree.getZTreeObj('tree_'+this.randomNumber);
				var node = treeObj.getNodes();
    			var nodes = treeObj.transformToArray(node);
				nodes.forEach( item => {
					if(isCheck==1){
					   item.checked = true;
					   this.selectCompanysArr.push(item.id);
					   this.$emit('input',this.selectCompanysArr)
					   this.selStatus="全部"
					}else{
						item.checked = false;
						this.$emit('input','');
						this.selStatus="请选择"
					}
				})
				treeObj.refresh();
			}
	    }
}
</script>

<style scoped>
.menuInputBrand {
	position: relative;
	cursor: default;
}
	
	.menuContent {
		position: absolute;
		top: 31px;
		left: 6px;
		border: 1px solid #ddd;
		z-index: 999;
		width:calc(100% - 10px);
		box-shadow:5px 5px 5px #ddd;
	}
	
	.menuContent p{
		padding-left:5px;
		background-color:#eee;
		margin-bottom:0; 
	}

	.select-down-arrow{
		width:0;
		height: 0;
		border-width: 5px 4px 0 4px;
		border-style:solid;
		border-color:#888 transparent transparent transparent;
		position:absolute;
		top:50%;
		right:5px;
	}
</style>


// WEBPACK FOOTER //
// MultiSelectTree.vue?1112a082